(function () {
  "use strict";

  // French dynamic selection labels; all other locales retain their existing copy.
  function frenchCopy(source, values) {
    var translations = {
      "Odobrať z výberu −": "Retirer de la sélection −",
      "Pridať do výberu +": "Ajouter à la sélection +",
      "Odobrať z môjho výberu": "Retirer de ma sélection",
      "Pridať do môjho výberu": "Ajouter à ma sélection",
      "Odobrať {title} z výberu": "Retirer {title} de la sélection",
      "Pridať {title} do výberu": "Ajouter {title} à la sélection",
      "{count} produktov vo výbere": "{count} produits dans la sélection",
      "Porovnať {title}": "Comparer {title}",
      "Porovnať": "Comparer",
      "Odobrať": "Retirer",
      "Vyberte aspoň 2 produkty.": "Sélectionnez au moins 2 produits.",
      "Vybraný 1 produkt. Vyberte ešte aspoň jeden.": "1 produit sélectionné. Ajoutez au moins un autre produit.",
      "Vybrané 4 produkty. To je maximum pre jedno porovnanie.": "4 produits sélectionnés : le maximum par comparaison.",
      "Vybrané {count} produkty na porovnanie.": "{count} produits sélectionnés pour la comparaison.",
      "Naraz možno porovnať najviac 4 produkty.": "Vous pouvez comparer jusqu’à 4 produits à la fois.",
      "Porovnanie vybraných produktov TERAVIA": "Comparaison des produits TERAVIA sélectionnés",
      "Vlastnosť": "Caractéristique",
      "Fotografia": "Photo",
      "Bez fotografie": "Sans photo",
      "Názov": "Nom",
      "Typ": "Type",
      "Cena": "Prix",
      "Výška": "Hauteur",
      "Šírka": "Largeur",
      "Silueta": "Silhouette",
      "Detail": "Détails",
      "Detail nie je dostupný": "Détails indisponibles",
      "Detail produktu →": "Voir le produit →"
    };
    var isFrench = String(document.documentElement.lang || "sk").toLowerCase().split("-")[0] === "fr";
    var result = isFrench && translations[source] ? translations[source] : source;
    return result.replace(/\{(title|count)\}/g, function (match, key) {
      return values && values[key] != null ? String(values[key]) : match;
    });
  }

  var FAVORITES_KEY = "botanicalis-favorites-v1";
  var COMPARISON_KEY = "botanicalis-comparison-v1";
  var favorites = [];
  var comparisonKeys = [];
  var quickCurrent = null;
  var focusBeforeSearch = null;
  var focusBeforeDrawer = null;
  var focusBeforeQuick = null;
  var focusBeforeComparison = null;
  var comparisonReturnToDrawer = false;
  var comparisonDrawerOpener = null;
  var favoriteValidationPromise = null;
  var advisorState = {
    space: "",
    shape: "",
    height: ""
  };
  var advisorStep = 1;

  function query(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function queryAll(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function asText(value) {
    return value == null ? "" : String(value).trim();
  }

  function normalized(value) {
    var text = asText(value).toLowerCase();

    if (typeof text.normalize === "function") {
      text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    return text.replace(/[^a-z0-9]+/g, " ").trim();
  }

  function slug(value) {
    return normalized(value).replace(/\s+/g, "-") || "produkt";
  }

  function isPlaceholder(value) {
    return value === true || value === "true" || value === "1";
  }

  function productKey(item) {
    if (item.placeholder || !item.id || !item.url || item.url === "#") {
      return "placeholder:" + slug(item.title);
    }

    return "product:" + asText(item.id);
  }

  function productFromData(data) {
    var item = {
      id: asText(data.productId || data.id),
      variantId: asText(data.variantId).split("/").pop(),
      available: data.available !== "false" && data.available !== "0",
      title: asText(data.title) || "Produkt TERAVIA",
      family: asText(data.family) || "Produkt",
      height: asText(data.height),
      width: asText(data.width),
      note: asText(data.note),
      price: asText(data.price),
      image: asText(data.image),
      url: asText(data.url) || "#",
      tags: asText(data.tags),
      space: asText(data.space),
      shape: asText(data.shape),
      heightGroup: asText(data.heightGroup),
      placeholder: isPlaceholder(data.placeholder)
    };

    if (!item.id || item.url === "#") {
      item.placeholder = true;
    }

    item.key = productKey(item);
    return item;
  }

  function productFromElement(element) {
    var card = element && element.closest ? element.closest("[data-product-card]") : null;
    return productFromData((card || element || {}).dataset || {});
  }

  function readFavorites() {
    var stored;
    var unique = new Map();

    try {
      stored = JSON.parse(window.localStorage.getItem(FAVORITES_KEY) || "[]");
    } catch (error) {
      stored = [];
    }

    if (!Array.isArray(stored)) {
      stored = [];
    }

    stored.slice(0, 50).forEach(function (saved) {
      var item = productFromData(saved || {});
      if (item.title) {
        unique.set(item.key, item);
      }
    });

    favorites = Array.from(unique.values());
  }

  function saveFavorites() {
    try {
      window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    } catch (error) {
      /* Private browsing or a full storage quota must not break the storefront. */
    }
  }

  function readComparison() {
    var stored;
    var favoriteKeys = new Set(favorites.map(function (item) { return item.key; }));

    try {
      stored = JSON.parse(window.sessionStorage.getItem(COMPARISON_KEY) || "[]");
    } catch (error) {
      stored = [];
    }

    if (!Array.isArray(stored)) stored = [];
    comparisonKeys = stored.map(asText).filter(function (key, index, all) {
      return key && favoriteKeys.has(key) && all.indexOf(key) === index;
    }).slice(0, 4);
  }

  function saveComparison() {
    try {
      window.sessionStorage.setItem(COMPARISON_KEY, JSON.stringify(comparisonKeys));
    } catch (error) {
      /* A disabled session store must not break saved products. */
    }
  }

  function formatMoneyFromCents(value) {
    var amount = Number(value) / 100;
    if (!Number.isFinite(amount)) return "";
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : "EUR";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "sk-SK", {
        style: "currency",
        currency: currency
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + " " + currency;
    }
  }

  function validateFavoriteAvailability() {
    if (favoriteValidationPromise) return favoriteValidationPromise;
    if (!favorites.length) return Promise.resolve([]);

    var checks = favorites.map(function (item) {
      if (item.placeholder || !item.url || item.url === "#") return Promise.resolve({ item: item, keep: false });

      var productUrl;
      try {
        productUrl = new URL(item.url, window.location.origin);
      } catch (error) {
        return Promise.resolve({ item: item, keep: true });
      }

      if (productUrl.origin !== window.location.origin || productUrl.pathname.indexOf("/products/") === -1) {
        return Promise.resolve({ item: item, keep: true });
      }

      productUrl.search = "";
      productUrl.hash = "";
      productUrl.pathname = productUrl.pathname.replace(/\.js$/, "") + ".js";

      return window.fetch(productUrl.toString(), { headers: { "Accept": "application/json" } })
        .then(function (response) {
          if (response.status === 404) return { item: item, keep: false };
          if (!response.ok) return { item: item, keep: true };
          return response.json().then(function (product) {
            var variants = Array.isArray(product.variants) ? product.variants : [];
            var selected = variants.find(function (variant) {
              return asText(variant.id) === asText(item.variantId) && variant.available;
            }) || variants.find(function (variant) { return variant.available; });
            if (!selected || product.available !== true) return { item: item, keep: false };

            return {
              keep: true,
              item: productFromData({
                productId: product.id || item.id,
                variantId: selected.id,
                available: true,
                title: product.title || item.title,
                family: product.type || item.family,
                height: item.height,
                width: item.width,
                note: item.note,
                price: formatMoneyFromCents(selected.price),
                image: product.featured_image || (Array.isArray(product.images) ? product.images[0] : "") || item.image,
                url: product.url || item.url,
                tags: item.tags,
                space: item.space,
                shape: item.shape,
                heightGroup: item.heightGroup,
                placeholder: false
              })
            };
          });
        })
        .catch(function () { return { item: item, keep: true }; });
    });

    favoriteValidationPromise = Promise.all(checks).then(function (results) {
      var currentSnapshot = JSON.stringify(favorites);
      var validated = results.filter(function (result) { return result.keep; }).map(function (result) { return result.item; });
      if (currentSnapshot === JSON.stringify(validated)) return validated;
      favorites = validated;
      saveFavorites();
      renderFavorites();
      return validated;
    }).finally(function () {
      favoriteValidationPromise = null;
    });

    return favoriteValidationPromise;
  }

  function favoriteByKey(key) {
    return favorites.some(function (item) {
      return item.key === key;
    });
  }

  function favoriteItemByKey(key) {
    return favorites.find(function (item) {
      return item.key === key;
    }) || null;
  }

  function safeProductUrl(item) {
    if (!item || item.placeholder || !item.url || item.url === "#") return "";

    try {
      var url = new URL(item.url, window.location.origin);
      if (url.origin !== window.location.origin || url.pathname.indexOf("/products/") === -1) return "";
      return url.href;
    } catch (error) {
      return "";
    }
  }

  function productTypeLabel(value) {
    var labels = {
      "Plant": "Živá rastlina",
      "Live Plant": "Živá rastlina",
      "Artificial Plant": "Umelá rastlina",
      "Artificial Tree": "Umelý strom",
      "Hanging Plant": "Visiaca rastlina",
      "Green Wall Panel": "Zelený stenový panel",
      "Branch & Stem": "Vetva a stonka",
      "Pot": "Kvetináč",
      "Planter": "Kvetináč",
      "Bouquet": "Kytica",
      "Artificial Bouquet": "Kytica",
      "Garland": "Girlanda",
      "Artificial Garland": "Girlanda",
      "Hedge": "Umelý živý plot",
      "Artificial Hedge": "Umelý živý plot",
      "Leaf": "Dekoratívny list",
      "Artificial Leaf": "Dekoratívny list",
      "Standard": "Produkt",
      "Náhradní díly pro plynové grily": "Náhradné diely pre plynové grily",
      "Příslušenství": "Príslušenstvo",
      "Popolnice": "Odpadkové nádoby",
      "Rudlíky": "Manipulačné vozíky",
      "Záhradný fúriky": "Záhradné fúriky",
      "Mulčovacia textílie": "Mulčovacie textílie",
      "Tieniace sieť": "Tieniace siete",
      "Drviče vetví": "Drviče konárov",
      "Benzinové píly": "Benzínové píly",
      "Trávne zmesy": "Trávne zmesi"
    };
    var base = labels[asText(value)] || asText(value) || "Produkt";
    var language = String(document.documentElement.lang || "sk").toLowerCase().split("-")[0];
    var localized = {
      de: { "Živá rastlina": "Lebende Pflanze", "Umelá rastlina": "Kunstpflanze", "Umelý strom": "Kunstbaum", "Visiaca rastlina": "Hängepflanze", "Zelený stenový panel": "Grünwandpaneel", "Vetva a stonka": "Zweig und Stiel", "Kvetináč": "Pflanzgefäß", "Kytica": "Blumenstrauß", "Girlanda": "Girlande", "Umelý živý plot": "Kunsthecke", "Dekoratívny list": "Dekoratives Blatt", "Produkt": "Produkt", "Príslušenstvo": "Zubehör" },
      fr: { "Živá rastlina": "Plante naturelle", "Umelá rastlina": "Plante artificielle", "Umelý strom": "Arbre artificiel", "Visiaca rastlina": "Plante retombante", "Zelený stenový panel": "Panneau végétal", "Vetva a stonka": "Branche et tige", "Kvetináč": "Pot de fleurs", "Kytica": "Bouquet", "Girlanda": "Guirlande", "Umelý živý plot": "Haie artificielle", "Dekoratívny list": "Feuille décorative", "Produkt": "Produit", "Príslušenstvo": "Accessoires" }
    };
    return localized[language] && localized[language][base] ? localized[language][base] : base;
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }

  function updateSelectionMail() {
    var link = query("[data-selection-mail]");
    if (!link) return;

    var mailBase = (link.getAttribute("href") || "mailto:").split("?")[0];
    var lines = [
      "Dobrý deň,",
      "",
      "prosím o dostupnosť a cenovú ponuku pre tento výber:"
    ];

    favorites.forEach(function (item) {
      var details = [item.family, item.height, item.width, item.price].filter(Boolean).join(" · ");
      var line = "- " + item.title + (details ? " | " + details : "");
      var productUrl = safeProductUrl(item);
      if (productUrl) line += " | " + productUrl;
      lines.push(line);
    });

    lines.push("", "Ďakujem.");
    link.href = mailBase + "?subject=" + encodeURIComponent("TERAVIA – overenie môjho výberu") + "&body=" + encodeURIComponent(lines.join("\n"));
  }

  function reconcileComparison() {
    var favoriteKeys = new Set(favorites.map(function (item) { return item.key; }));
    var nextKeys = comparisonKeys.filter(function (key, index, all) {
      return favoriteKeys.has(key) && all.indexOf(key) === index;
    }).slice(0, 4);

    if (JSON.stringify(nextKeys) !== JSON.stringify(comparisonKeys)) {
      comparisonKeys = nextKeys;
      saveComparison();
    }
  }

  function updateComparisonControls(message) {
    var count = comparisonKeys.length;
    var openButton = query("[data-compare-open]");
    var countNode = query("[data-compare-count]");
    var status = query("[data-compare-status]");

    if (countNode) countNode.textContent = "(" + count + ")";
    if (openButton) {
      openButton.disabled = count < 2;
      openButton.setAttribute("aria-disabled", count < 2 ? "true" : "false");
    }

    queryAll("[data-compare-toggle]").forEach(function (checkbox) {
      var selected = comparisonKeys.indexOf(checkbox.dataset.compareToggle) !== -1;
      checkbox.checked = selected;
      checkbox.disabled = !selected && count >= 4;
      var label = checkbox.closest(".drawer-compare-option");
      if (label) label.classList.toggle("is-disabled", checkbox.disabled);
    });

    if (!status) return;
    if (message) {
      status.textContent = message;
    } else if (count === 0) {
      status.textContent = frenchCopy("Vyberte aspoň 2 produkty.");
    } else if (count === 1) {
      status.textContent = frenchCopy("Vybraný 1 produkt. Vyberte ešte aspoň jeden.");
    } else if (count === 4) {
      status.textContent = frenchCopy("Vybrané 4 produkty. To je maximum pre jedno porovnanie.");
    } else {
      status.textContent = frenchCopy("Vybrané {count} produkty na porovnanie.", { count: count });
    }
  }

  function safeImageUrl(value) {
    if (!value) return "";
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === "https:" || (url.protocol === "http:" && url.origin === window.location.origin) ? url.href : "";
    } catch (error) {
      return "";
    }
  }

  function addComparisonRow(body, label, items, valueForItem) {
    var row = createElement("tr");
    var heading = createElement("th", "", label);
    heading.scope = "row";
    row.append(heading);

    items.forEach(function (item, index) {
      var cell = createElement("td");
      valueForItem(cell, item, index);
      row.append(cell);
    });

    body.append(row);
  }

  function renderComparisonTable() {
    var container = query("[data-comparison-table]");
    if (!container) return;

    var items = comparisonKeys.map(favoriteItemByKey).filter(Boolean).slice(0, 4);
    container.replaceChildren();
    if (items.length < 2) return;

    var table = createElement("table", "comparison-table");
    var caption = createElement("caption", "botanicalis-sr-only", frenchCopy("Porovnanie vybraných produktov TERAVIA"));
    var head = createElement("thead");
    var headRow = createElement("tr");
    var propertyHeading = createElement("th", "", frenchCopy("Vlastnosť"));
    propertyHeading.scope = "col";
    headRow.append(propertyHeading);

    items.forEach(function (item, index) {
      var productHeading = createElement("th", "", "Produkt " + (index + 1));
      productHeading.scope = "col";
      headRow.append(productHeading);
    });
    head.append(headRow);

    var body = createElement("tbody");
    addComparisonRow(body, frenchCopy("Fotografia"), items, function (cell, item) {
      var imageUrl = safeImageUrl(item.image);
      if (!imageUrl) {
        cell.textContent = frenchCopy("Bez fotografie");
        return;
      }
      var image = createElement("img");
      image.src = imageUrl;
      image.alt = item.title;
      image.loading = "lazy";
      image.width = 220;
      image.height = 280;
      cell.append(image);
    });
    addComparisonRow(body, frenchCopy("Názov"), items, function (cell, item) { cell.textContent = item.title || "—"; });
    addComparisonRow(body, frenchCopy("Typ"), items, function (cell, item) { cell.textContent = productTypeLabel(item.family); });
    addComparisonRow(body, frenchCopy("Cena"), items, function (cell, item) { cell.textContent = item.price || "—"; });
    addComparisonRow(body, frenchCopy("Výška"), items, function (cell, item) { cell.textContent = item.height || "—"; });
    addComparisonRow(body, frenchCopy("Šírka"), items, function (cell, item) { cell.textContent = item.width || "—"; });
    addComparisonRow(body, frenchCopy("Silueta"), items, function (cell, item) { cell.textContent = item.shape || "—"; });
    addComparisonRow(body, frenchCopy("Detail"), items, function (cell, item) {
      var url = safeProductUrl(item);
      if (!url) {
        cell.textContent = frenchCopy("Detail nie je dostupný");
        return;
      }
      var link = createElement("a", "", frenchCopy("Detail produktu →"));
      link.href = url;
      cell.append(link);
    });

    table.append(caption, head, body);
    container.append(table);
  }

  function toggleComparison(key, selected) {
    var index = comparisonKeys.indexOf(key);

    if (selected && index === -1) {
      if (comparisonKeys.length >= 4) {
        updateComparisonControls(frenchCopy("Naraz možno porovnať najviac 4 produkty."));
        return;
      }
      if (favoriteItemByKey(key)) comparisonKeys.push(key);
    } else if (!selected && index !== -1) {
      comparisonKeys.splice(index, 1);
    }

    saveComparison();
    updateComparisonControls();
  }

  function updateFavoriteButtons() {
    queryAll(".js-favorite-toggle").forEach(function (button) {
      var item = productFromElement(button);
      var selected = favoriteByKey(item.key);
      button.classList.toggle("is-favorite", selected);
      button.setAttribute("aria-pressed", selected ? "true" : "false");

      if (button.classList.contains("heart-button")) {
        button.setAttribute("aria-label", frenchCopy(selected ? "Odobrať {title} z výberu" : "Pridať {title} do výberu", { title: item.title }));
      } else {
        button.textContent = frenchCopy(selected ? "Odobrať z výberu −" : "Pridať do výberu +");
      }
    });

    var quickButton = query("[data-quick-favorite]");
    if (quickButton && quickCurrent) {
      var selected = favoriteByKey(quickCurrent.key);
      quickButton.classList.toggle("is-favorite", selected);
      quickButton.setAttribute("aria-pressed", selected ? "true" : "false");
      quickButton.textContent = frenchCopy(selected ? "Odobrať z môjho výberu" : "Pridať do môjho výberu");
    }
  }

  function renderFavorites() {
    reconcileComparison();
    var count = favorites.length;
    var products = query("[data-drawer-products]");
    var empty = query("[data-drawer-empty]");
    var foot = query("[data-drawer-foot]");

    queryAll("[data-favorite-count], [data-drawer-count]").forEach(function (element) {
      element.textContent = String(count);
      element.setAttribute("aria-label", frenchCopy("{count} produktov vo výbere", { count: count }));
    });

    queryAll(".js-selection-open svg, .selection-button svg").forEach(function (icon) {
      icon.classList.toggle("filled", count > 0);
    });

    if (empty) empty.hidden = count > 0;
    if (foot) foot.hidden = count === 0;

    if (products) {
      products.replaceChildren();

      favorites.forEach(function (item) {
        var article = createElement("article");
        var image = createElement("img");
        var copy = createElement("div");
        var family = createElement("small", "", item.family || "Produkt");
        var title;
        var meta = createElement("span", "", [item.height, item.width, item.price].filter(Boolean).join(" · "));
        var compareLabel = createElement("label", "drawer-compare-option");
        var compareInput = createElement("input");
        var compareText = createElement("span", "", frenchCopy("Porovnať"));
        var remove = createElement("button", "drawer-remove", frenchCopy("Odobrať"));

        image.src = item.image || "";
        image.alt = item.title;
        image.loading = "lazy";
        image.width = 164;
        image.height = 208;

        if (!item.placeholder && item.url && item.url !== "#") {
          title = createElement("a", "", item.title);
          title.href = item.url;
        } else {
          title = createElement("strong", "", item.title);
        }

        remove.type = "button";
        remove.dataset.favoriteRemove = item.key;
        remove.setAttribute("aria-label", frenchCopy("Odobrať {title} z výberu", { title: item.title }));

        compareInput.type = "checkbox";
        compareInput.dataset.compareToggle = item.key;
        compareInput.checked = comparisonKeys.indexOf(item.key) !== -1;
        compareInput.setAttribute("aria-label", frenchCopy("Porovnať {title}", { title: item.title }));
        compareLabel.append(compareInput, compareText);

        copy.append(family, title);
        if (meta.textContent) copy.append(meta);
        copy.append(compareLabel);
        copy.append(remove);
        article.append(image, copy);
        products.append(article);
      });
    }

    updateSelectionMail();
    updateFavoriteButtons();
    updateComparisonControls();
  }

  function addToCart(item, button) {
    if (!item || item.placeholder || !item.variantId || item.available === false) {
      if (item && item.url && item.url !== "#") window.location.assign(item.url);
      return;
    }

    var originalText = button ? button.textContent : "";
    var cartLanguage = String(document.documentElement.lang || "sk").toLowerCase().split("-")[0];
    var cartLabels = {
      de: {
        adding: "Wird hinzugefügt…",
        add: "In den Warenkorb +",
        error: "Das Produkt konnte nicht zum Warenkorb hinzugefügt werden. Bitte versuchen Sie es erneut."
      },
      fr: {
        adding: "Ajout en cours…",
        add: "Ajouter au panier +",
        error: "Impossible d’ajouter le produit au panier. Veuillez réessayer."
      }
    }[cartLanguage] || {
      adding: "Pridávam…",
      add: "Do košíka +",
      error: "Produkt sa nepodarilo pridať do košíka. Skúste to, prosím, znova."
    };
    if (button) {
      button.disabled = true;
      button.textContent = cartLabels.adding;
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

    window.fetch(root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: [{ id: Number(item.variantId), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error("cart-add-failed");
      return response.json();
    }).then(function () {
      window.location.assign(root + "cart");
    }).catch(function () {
      if (button) {
        button.disabled = false;
        button.textContent = originalText || cartLabels.add;
      }
      window.alert(cartLabels.error);
    });
  }

  function toggleFavorite(item) {
    var index = favorites.findIndex(function (saved) {
      return saved.key === item.key;
    });

    if (index === -1) {
      favorites.push(item);
    } else {
      favorites.splice(index, 1);
    }

    saveFavorites();
    renderFavorites();
  }

  function removeFavorite(key) {
    favorites = favorites.filter(function (item) {
      return item.key !== key;
    });
    saveFavorites();
    renderFavorites();
  }

  function syncBodyLock() {
    var search = query("[data-search-overlay]");
    var drawer = query("[data-selection-drawer]");
    var quick = query("[data-quick-backdrop]");
    var comparison = query("[data-comparison-overlay]");
    var locked = Boolean(
      (search && !search.hidden) ||
      (drawer && drawer.classList.contains("open")) ||
      (quick && !quick.hidden) ||
      (comparison && !comparison.hidden)
    );

    document.body.style.overflow = locked ? "hidden" : "";
  }

  function restoreFocus(element) {
    if (element && document.contains(element) && typeof element.focus === "function") {
      element.focus();
    }
  }

  function submenuPanel(toggle) {
    if (!toggle) return null;
    var panelId = toggle.getAttribute("aria-controls");
    return panelId ? document.getElementById(panelId) : null;
  }

  function setSubmenuState(toggle, expanded, restore) {
    var panel = submenuPanel(toggle);
    if (!toggle || !panel) return;

    var item = toggle.closest("[data-submenu-item]");
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    panel.hidden = !expanded;
    panel.setAttribute("aria-hidden", expanded ? "false" : "true");
    if (item) item.classList.toggle("is-submenu-open", expanded);

    if (!expanded && restore) restoreFocus(toggle);
  }

  function closeSubmenus(except, restore) {
    var focusTarget = null;

    queryAll("[data-submenu-toggle][aria-expanded='true']").forEach(function (toggle) {
      if (toggle === except) return;
      if (!focusTarget) focusTarget = toggle;
      setSubmenuState(toggle, false, false);
    });

    if (restore && focusTarget) restoreFocus(focusTarget);
  }

  function toggleSubmenu(toggle) {
    var shouldOpen = toggle.getAttribute("aria-expanded") !== "true";
    if (shouldOpen) closeSubmenus(toggle, false);
    setSubmenuState(toggle, shouldOpen, false);
  }

  function syncSubmenuAccessibility() {
    queryAll("[data-submenu-toggle]").forEach(function (toggle) {
      setSubmenuState(toggle, toggle.getAttribute("aria-expanded") === "true", false);
    });
  }

  function closeMenu(restore) {
    var button = query("[data-menu-button]");
    var nav = query("[data-main-nav]");
    if (!button || !nav) return;

    var wasOpen = nav.classList.contains("nav-open");
    closeSubmenus(null, false);
    nav.classList.remove("nav-open");
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-label", "Otvoriť menu");
    syncMenuAccessibility();
    if (restore !== false && wasOpen) restoreFocus(button);
  }

  function openMenu() {
    var button = query("[data-menu-button]");
    var nav = query("[data-main-nav]");
    if (!button || !nav) return;

    closeSearch(false);
    closeDrawer(false);
    closeQuick(false);
    nav.classList.add("nav-open");
    button.setAttribute("aria-expanded", "true");
    button.setAttribute("aria-label", "Zavrieť menu");
    syncMenuAccessibility();

    window.setTimeout(function () {
      var firstLink = query("[data-submenu-toggle], a", nav);
      if (firstLink) firstLink.focus();
    }, 0);
  }

  function syncMenuAccessibility() {
    var button = query("[data-menu-button]");
    var nav = query("[data-main-nav]");
    if (!button || !nav) return;

    if (!nav.id) nav.id = "BotanicalisMainNavigation";
    button.setAttribute("aria-controls", nav.id);

    if (window.matchMedia("(max-width: 1180px)").matches) {
      var mobileMenuOpen = nav.classList.contains("nav-open");
      nav.setAttribute("aria-hidden", mobileMenuOpen ? "false" : "true");
      if (!mobileMenuOpen) closeSubmenus(null, false);
    } else {
      nav.removeAttribute("aria-hidden");
      if (nav.classList.contains("nav-open")) {
        nav.classList.remove("nav-open");
        closeSubmenus(null, false);
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-label", "Otvoriť menu");
      }
    }
  }

  function openSearch(opener) {
    var overlay = query("[data-search-overlay]");
    var input = query("[data-search-input]");
    if (!overlay) return;

    closeMenu(false);
    closeDrawer(false);
    closeQuick(false);
    focusBeforeSearch = opener || document.activeElement;
    overlay.hidden = false;
    overlay.setAttribute("aria-hidden", "false");
    syncBodyLock();

    window.setTimeout(function () {
      if (input) {
        input.focus();
      }
    }, 0);
  }

  function closeSearch(restore) {
    var overlay = query("[data-search-overlay]");
    if (!overlay || overlay.hidden) return;

    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    syncBodyLock();
    if (restore !== false) restoreFocus(focusBeforeSearch);
    focusBeforeSearch = null;
  }

  function openDrawer(opener) {
    var drawer = query("[data-selection-drawer]");
    var backdrop = query("[data-drawer-backdrop]");
    if (!drawer) return;

    closeMenu(false);
    closeSearch(false);
    closeQuick(false);
    focusBeforeDrawer = opener || document.activeElement;
    drawer.inert = false;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    if (backdrop) backdrop.classList.add("visible");
    syncBodyLock();
    validateFavoriteAvailability();

    window.setTimeout(function () {
      var close = query(".js-selection-close", drawer);
      if (close) close.focus();
    }, 0);
  }

  function closeDrawer(restore) {
    var drawer = query("[data-selection-drawer]");
    var backdrop = query("[data-drawer-backdrop]");
    if (!drawer) return;

    var wasOpen = drawer.classList.contains("open");
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    drawer.inert = true;
    if (backdrop) backdrop.classList.remove("visible");
    syncBodyLock();
    if (restore !== false && wasOpen) restoreFocus(focusBeforeDrawer);
    focusBeforeDrawer = null;
  }

  function openComparison(opener) {
    var overlay = query("[data-comparison-overlay]");
    var drawer = query("[data-selection-drawer]");
    if (!overlay || comparisonKeys.length < 2) return;

    comparisonReturnToDrawer = Boolean(drawer && drawer.classList.contains("open"));
    comparisonDrawerOpener = focusBeforeDrawer;
    focusBeforeComparison = opener || document.activeElement;
    if (comparisonReturnToDrawer) closeDrawer(false);
    closeSearch(false);
    closeQuick(false);
    renderComparisonTable();
    overlay.hidden = false;
    overlay.setAttribute("aria-hidden", "false");
    syncBodyLock();

    window.setTimeout(function () {
      var close = query(".comparison-head [data-comparison-close]", overlay);
      if (close) close.focus();
    }, 0);
  }

  function closeComparison(restore, returnToDrawer) {
    var overlay = query("[data-comparison-overlay]");
    if (!overlay || overlay.hidden) return;

    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    syncBodyLock();

    var shouldReturnToDrawer = comparisonReturnToDrawer && returnToDrawer !== false;
    var comparisonTrigger = focusBeforeComparison;
    var drawerOpener = comparisonDrawerOpener;
    focusBeforeComparison = null;
    comparisonReturnToDrawer = false;
    comparisonDrawerOpener = null;

    if (shouldReturnToDrawer) {
      openDrawer(drawerOpener || query(".js-selection-open"));
      if (restore !== false) window.setTimeout(function () { restoreFocus(comparisonTrigger); }, 0);
    } else if (restore !== false) {
      restoreFocus(comparisonTrigger);
    }
  }

  function setQuickText(selector, value) {
    var element = query(selector);
    if (element) element.textContent = value || "—";
  }

  function openQuick(item, opener) {
    var backdrop = query("[data-quick-backdrop]");
    if (!backdrop) {
      if (!item.placeholder && item.url && item.url !== "#") window.location.assign(item.url);
      return;
    }

    closeMenu(false);
    closeSearch(false);
    closeDrawer(false);
    quickCurrent = item;
    focusBeforeQuick = opener || document.activeElement;

    var image = query("[data-quick-image]");
    var link = query("[data-quick-link]");
    if (image) {
      image.src = item.image || "";
      image.alt = item.title;
    }

    setQuickText("[data-quick-badge]", item.placeholder ? "Ukážkový produkt" : "Produkt");
    setQuickText("[data-quick-family]", item.family || "Produkt");
    setQuickText("[data-quick-title]", item.title);
    setQuickText("[data-quick-note]", item.note || "Podrobnosti doplníme po overení produktu.");
    setQuickText("[data-quick-height]", item.height);
    setQuickText("[data-quick-shape]", item.shape);
    setQuickText("[data-quick-width]", item.width);
    setQuickText("[data-quick-price]", item.price || (item.placeholder ? "Cena po spustení" : "Cena v detaile"));

    if (link) {
      var hasLink = !item.placeholder && item.url && item.url !== "#";
      link.hidden = !hasLink;
      if (hasLink) link.href = item.url;
    }

    var quickCart = query("[data-quick-cart]");
    if (quickCart) {
      quickCart.disabled = item.placeholder || !item.variantId || item.available === false;
      quickCart.textContent = item.available === false ? "Momentálne vypredané" : "Pridať do košíka";
    }

    backdrop.hidden = false;
    backdrop.setAttribute("aria-hidden", "false");
    updateFavoriteButtons();
    syncBodyLock();

    window.setTimeout(function () {
      var close = query(".quick-modal .js-quick-close", backdrop);
      if (close) close.focus();
    }, 0);
  }

  function closeQuick(restore) {
    var backdrop = query("[data-quick-backdrop]");
    if (!backdrop || backdrop.hidden) return;

    backdrop.hidden = true;
    backdrop.setAttribute("aria-hidden", "true");
    syncBodyLock();
    if (restore !== false) restoreFocus(focusBeforeQuick);
    focusBeforeQuick = null;
    quickCurrent = null;
  }

  function setFaqItem(item, open) {
    var button = query(":scope > button", item);
    var panel = query(":scope > div", item);
    var symbol = button ? query("b", button) : null;
    if (!button || !panel) return;

    item.classList.toggle("open", open);
    button.setAttribute("aria-expanded", open ? "true" : "false");
    panel.setAttribute("aria-hidden", open ? "false" : "true");
    if (symbol) symbol.textContent = open ? "−" : "+";
  }

  function initializeFaq() {
    queryAll(".faq-item").forEach(function (item, index) {
      var button = query(":scope > button", item);
      var panel = query(":scope > div", item);
      if (!button || !panel) return;

      if (!button.id) button.id = "BotanicalisFaqButton-" + index;
      if (!panel.id) panel.id = "BotanicalisFaqPanel-" + index;
      button.setAttribute("aria-controls", panel.id);
      panel.setAttribute("role", "region");
      panel.setAttribute("aria-labelledby", button.id);
      var symbol = query("b", button);
      if (symbol) symbol.setAttribute("aria-hidden", "true");
      setFaqItem(item, item.classList.contains("open"));
    });
  }

  var advisorLabels = {
    space: {
      apartment: "Do bytu",
      home: "Do domu",
      office: "Do kancelárie",
      hospitality: "Pre hotel, gastro & retail"
    },
    shape: {
      narrow: "úzka do rohu",
      wide: "široká koruna",
      tall: "vysoká a výrazná",
      hanging: "visiaca",
      wall: "zelená stena",
      branch: "vetvy do vázy"
    },
    height: {
      compact: "do 120 cm",
      medium: "121–190 cm",
      large: "nad 190 cm"
    }
  };

  var advisorCollectionUrls = {
    narrow: "/collections/uzke-a-vyssie-rastliny",
    wide: "/collections/poradca-siroka-koruna",
    tall: "/collections/vysoke-a-vyrazne-rastliny",
    hanging: "/collections/visiace-rastliny",
    wall: "/collections/zelene-steny",
    branch: "/collections/vetvy-a-stonky"
  };

  function setAdvisorActiveStates() {
    queryAll("[data-advisor-space]").forEach(function (button) {
      var active = button.dataset.advisorSpace === advisorState.space;
      if (button.closest("[data-advisor]")) button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });

    queryAll("[data-advisor-shape]").forEach(function (button) {
      var active = button.dataset.advisorShape === advisorState.shape;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });

    queryAll("[data-advisor-height]").forEach(function (button) {
      var active = button.dataset.advisorHeight === advisorState.height;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateRecommendationHeading() {
    var heading = query("[data-recommendation-heading]");
    if (!heading) return;
    if (!advisorState.shape) {
      heading.textContent = "Odpovedzte na tri otázky";
      return;
    }

    var prefix = advisorLabels.space[advisorState.space] ? advisorLabels.space[advisorState.space] + ": " : "";
    var suffix = shapeNeedsHeight(advisorState.shape) && advisorLabels.height[advisorState.height]
      ? " · " + advisorLabels.height[advisorState.height]
      : "";
    heading.textContent = prefix + advisorLabels.shape[advisorState.shape] + suffix;
  }

  function setAdvisorStep(step, moveFocus) {
    var advisor = query("[data-advisor]");
    if (!advisor) return;

    advisorStep = Math.max(1, Math.min(3, Number(step) || 1));
    queryAll("[data-advisor-step]", advisor).forEach(function (panel) {
      var active = Number(panel.dataset.advisorStep) === advisorStep;
      panel.hidden = !active;
      panel.setAttribute("aria-hidden", active ? "false" : "true");
    });

    var progress = query("[data-advisor-progress]", advisor);
    var label = query("[data-advisor-progress-label]", advisor);
    if (progress) progress.style.width = (advisorStep / 3 * 100) + "%";
    if (label) label.textContent = "Krok " + advisorStep + " z 3";

    setAdvisorActiveStates();
    updateRecommendationHeading();

    if (moveFocus) {
      window.setTimeout(function () {
        var activePanel = query('[data-advisor-step="' + advisorStep + '"]', advisor);
        var firstButton = activePanel ? query("button", activePanel) : null;
        if (firstButton) firstButton.focus();
      }, 0);
    }
  }

  function shapeNeedsHeight(shape) {
    return shape === "narrow" || shape === "wide";
  }

  function updateAdvisorHeightAvailability() {
    var grid = query('[data-recommendation-grid="' + advisorState.shape + '"]');
    var availableGroups = new Set();

    if (grid) {
      queryAll("[data-product-card]", grid).forEach(function (card) {
        var item = productFromElement(card);
        if (
          item.available &&
          !item.placeholder &&
          advisorShapeMatch(item, advisorState.shape) &&
          advisorSpaceMatch(item, advisorState.shape)
        ) {
          availableGroups.add(inferredHeight(item));
        }
      });
    }

    queryAll("[data-advisor-height]").forEach(function (button) {
      var available = availableGroups.has(button.dataset.advisorHeight);
      button.hidden = !available;
      button.disabled = !available;
      button.setAttribute("aria-disabled", available ? "false" : "true");
    });
  }

  function updateAdvisorShapeAvailability() {
    queryAll("[data-advisor-shape]").forEach(function (button) {
      var shape = button.dataset.advisorShape;
      var grid = query('[data-recommendation-grid="' + shape + '"]');
      var available = Boolean(grid) && queryAll("[data-product-card]", grid).some(function (card) {
        var item = productFromElement(card);
        return item.available && !item.placeholder && advisorShapeMatch(item, shape) && advisorSpaceMatch(item, shape);
      });
      button.hidden = !available;
      button.disabled = !available;
      button.setAttribute("aria-disabled", available ? "false" : "true");
    });
  }

  function exactType(item, expected) {
    return asText(item.family).toLowerCase() === expected.toLowerCase();
  }

  function hasExactTag(item, expected) {
    var normalizedExpected = asText(expected).toLowerCase();
    return asText(item.tags).split(",").some(function (tag) {
      return tag.trim().toLowerCase() === normalizedExpected;
    });
  }

  function advisorSpaceMatch(item, shape) {
    var effectiveShape = shape || advisorState.shape;
    if (effectiveShape === "wall" || effectiveShape === "hanging" || effectiveShape === "branch") return true;
    if (!advisorState.space) return true;
    if (advisorState.space === "apartment") return hasExactTag(item, "space-apartment");
    if (advisorState.space === "home") return hasExactTag(item, "space-house");
    if (advisorState.space === "office") return hasExactTag(item, "space-office");
    if (advisorState.space === "hospitality") {
      return hasExactTag(item, "space-hotel") || hasExactTag(item, "space-gastro") || hasExactTag(item, "space-retail");
    }
    return false;
  }

  function inferredHeight(item) {
    var parsedHeight = parseFloat(asText(item.height).replace(",", "."));
    if (Number.isFinite(parsedHeight)) {
      if (parsedHeight <= 120) return "compact";
      if (parsedHeight <= 190) return "medium";
      return "large";
    }
    return item.heightGroup || "";
  }

  function advisorShapeMatch(item, shape) {
    if (shape === "narrow" || shape === "wide") {
      return (
        (exactType(item, "Artificial Plant") || exactType(item, "Artificial Tree")) &&
        hasExactTag(item, shape === "narrow" ? "shape-slim" : "shape-wide")
      );
    }
    if (shape === "tall") return exactType(item, "Artificial Plant") || exactType(item, "Artificial Tree");
    if (shape === "hanging") return exactType(item, "Hanging Plant");
    if (shape === "wall") return exactType(item, "Green Wall Panel");
    if (shape === "branch") return exactType(item, "Branch & Stem");
    return false;
  }

  function strictAdvisorMatch(item) {
    if (!item.available || item.placeholder || !advisorState.shape) return false;

    if (!advisorShapeMatch(item, advisorState.shape)) return false;
    if (!advisorSpaceMatch(item, advisorState.shape)) return false;

    return !shapeNeedsHeight(advisorState.shape) || inferredHeight(item) === advisorState.height;
  }

  function activeCarouselTrack(scope) {
    return query("[data-product-track]:not([hidden])", scope);
  }

  function syncCarousel(scope) {
    if (!scope) return;
    var track = activeCarouselTrack(scope);
    var previous = query("[data-carousel-prev]", scope);
    var next = query("[data-carousel-next]", scope);
    if (!track) {
      if (previous) previous.disabled = true;
      if (next) next.disabled = true;
      return;
    }
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    if (previous) previous.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
  }

  function syncRecommendationControls() {
    var scope = query("#recommendations");
    var controls = query("[data-recommendation-controls]", scope);
    var track = activeCarouselTrack(scope);
    if (!controls) return;
    controls.hidden = !track || track.scrollWidth <= track.clientWidth + 2;
    syncCarousel(scope);
  }

  function initializeCarousels() {
    queryAll("[data-carousel-scope]").forEach(function (scope) {
      queryAll("[data-product-track]", scope).forEach(function (track) {
        if (track.dataset.carouselReady) return;
        track.dataset.carouselReady = "true";
        track.addEventListener("scroll", function () {
          syncCarousel(scope);
        }, { passive: true });
      });
      syncCarousel(scope);
    });
  }

  function moveCarousel(button, direction) {
    var scope = button.closest("[data-carousel-scope]");
    var track = activeCarouselTrack(scope);
    if (!track) return;
    var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    track.scrollBy({
      left: direction * Math.max(track.clientWidth * 0.92, 240),
      behavior: reducedMotion ? "auto" : "smooth"
    });
    window.setTimeout(function () { syncCarousel(scope); }, reducedMotion ? 0 : 350);
  }

  function rankRecommendations(shouldScroll) {
    var grids = queryAll("[data-recommendation-grid]");
    var grid = query('[data-recommendation-grid="' + advisorState.shape + '"]');
    if (!grids.length || !grid || (shapeNeedsHeight(advisorState.shape) && !advisorState.height)) return;

    var recommendations = query("#recommendations");
    if (recommendations) recommendations.hidden = false;

    grids.forEach(function (candidate) {
      candidate.hidden = candidate !== grid;
    });

    var cards = queryAll("[data-product-card]", grid);
    var eligible = [];
    cards.forEach(function (card) {
      var matches = strictAdvisorMatch(productFromElement(card));
      card.classList.toggle("is-advisor-hidden", !matches);
      if (matches) eligible.push(card);
    });
    eligible.sort(function (left, right) {
      return Number(advisorSpaceMatch(productFromElement(right))) - Number(advisorSpaceMatch(productFromElement(left)));
    });
    eligible.forEach(function (card) { grid.append(card); });
    grid.scrollLeft = 0;

    var empty = query("[data-recommendation-empty]", grid);
    if (empty) empty.hidden = eligible.length > 0;

    var summary = query("[data-recommendation-summary]");
    if (summary) {
      summary.hidden = false;
      if (eligible.length === 0) {
        summary.textContent = "Pre túto presnú kombináciu momentálne nemáme zhodu. Pozrite si všetky produkty v tejto kategórii.";
      } else if (eligible.length > 4) {
        summary.textContent = "Zobrazujeme najpresnejšie zhody. Ďalšie si prezrite šípkami alebo otvorte celú kategóriu.";
      } else {
        summary.textContent = "Zobrazujeme najpresnejšie zhody. Ďalšie možnosti nájdete v celej kategórii.";
      }
    }

    var more = query("[data-advisor-more]");
    if (more) {
      more.hidden = false;
      more.href = advisorCollectionUrls[advisorState.shape] || "/collections/all";
    }

    updateRecommendationHeading();
    window.requestAnimationFrame(syncRecommendationControls);
    if (!shapeNeedsHeight(advisorState.shape)) {
      var progress = query("[data-advisor-progress]");
      var progressLabel = query("[data-advisor-progress-label]");
      if (progress) progress.style.width = "100%";
      if (progressLabel) progressLabel.textContent = "Výber je pripravený";
    }
    if (shouldScroll) {
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (recommendations) recommendations.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
    }
  }

  function resetRecommendationResults() {
    queryAll("[data-recommendation-grid]").forEach(function (grid) {
      grid.hidden = true;
      grid.scrollLeft = 0;
      queryAll("[data-product-card]", grid).forEach(function (card) {
        card.classList.remove("is-advisor-hidden");
      });
    });
    var controls = query("[data-recommendation-controls]");
    if (controls) controls.hidden = true;
    var summary = query("[data-recommendation-summary]");
    if (summary) {
      summary.hidden = true;
      summary.textContent = "";
    }
    var more = query("[data-advisor-more]");
    if (more) more.hidden = true;
    var recommendations = query("#recommendations");
    if (recommendations) recommendations.hidden = true;
    updateRecommendationHeading();
  }

  function initializeAdvisor() {
    if (!query("[data-advisor]")) return;
    setAdvisorStep(advisorStep, false);
    resetRecommendationResults();
  }

  function activeDialog() {
    var comparison = query("[data-comparison-overlay]");
    var quick = query("[data-quick-backdrop]");
    var search = query("[data-search-overlay]");
    var drawer = query("[data-selection-drawer]");

    if (comparison && !comparison.hidden) return query(".comparison-modal", comparison) || comparison;
    if (quick && !quick.hidden) return query(".quick-modal", quick) || quick;
    if (search && !search.hidden) return search;
    if (drawer && drawer.classList.contains("open")) return drawer;
    return null;
  }

  function focusableElements(scope) {
    return queryAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', scope).filter(function (element) {
      return !element.hidden && element.getClientRects().length > 0;
    });
  }

  function trapFocus(event) {
    var dialog = activeDialog();
    if (!dialog || event.key !== "Tab") return;

    var focusable = focusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.setAttribute("tabindex", "-1");
      dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initializeAccessibility() {
    var search = query("[data-search-overlay]");
    var drawer = query("[data-selection-drawer]");
    var comparison = query("[data-comparison-overlay]");
    var drawerTitle = drawer ? query(".drawer-head h2", drawer) : null;

    if (search) search.setAttribute("aria-hidden", search.hidden ? "true" : "false");
    if (comparison) comparison.setAttribute("aria-hidden", comparison.hidden ? "true" : "false");
    if (drawer) {
      drawer.setAttribute("role", "dialog");
      drawer.setAttribute("aria-modal", "true");
      drawer.inert = !drawer.classList.contains("open");
      if (drawerTitle) {
        if (!drawerTitle.id) drawerTitle.id = "BotanicalisSelectionTitle";
        drawer.setAttribute("aria-labelledby", drawerTitle.id);
      }
    }

    queryAll("[data-favorite-count]").forEach(function (count) {
      count.setAttribute("aria-live", "polite");
    });

    syncMenuAccessibility();
    syncSubmenuAccessibility();
  }

  function handleClick(event) {
    if (!(event.target instanceof Element)) return;
    var target = event.target;
    var match;

    match = target.closest("[data-carousel-prev], [data-carousel-next]");
    if (match) {
      event.preventDefault();
      moveCarousel(match, match.hasAttribute("data-carousel-prev") ? -1 : 1);
      return;
    }

    match = target.closest('[data-menu-button], a[href="/collections/all#TeraviaCatalogAreas"]');
    if (match) {
      event.preventDefault();
      var nav = query("[data-main-nav]");
      if (nav && nav.classList.contains("nav-open")) closeMenu();
      else openMenu();
      return;
    }

    match = target.closest("[data-submenu-toggle]");
    if (match) {
      event.preventDefault();
      toggleSubmenu(match);
      return;
    }

    match = target.closest(".js-search-open");
    if (match) {
      event.preventDefault();
      openSearch(match);
      return;
    }

    if (target.closest(".js-search-close")) {
      event.preventDefault();
      closeSearch();
      return;
    }

    match = target.closest(".js-selection-open");
    if (match) {
      event.preventDefault();
      openDrawer(match);
      return;
    }

    if (target.closest(".js-selection-close")) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (target.closest("[data-drawer-backdrop]")) {
      closeDrawer();
      return;
    }

    match = target.closest("[data-compare-open]");
    if (match) {
      event.preventDefault();
      openComparison(match);
      return;
    }

    if (target.closest("[data-comparison-close]")) {
      event.preventDefault();
      closeComparison();
      return;
    }

    match = target.closest("[data-favorite-remove]");
    if (match) {
      event.preventDefault();
      removeFavorite(match.dataset.favoriteRemove);
      return;
    }

    match = target.closest(".js-add-to-cart");
    if (match) {
      event.preventDefault();
      addToCart(productFromElement(match), match);
      return;
    }

    match = target.closest("[data-quick-cart]");
    if (match) {
      event.preventDefault();
      if (quickCurrent) addToCart(quickCurrent, match);
      return;
    }

    match = target.closest(".js-favorite-toggle");
    if (match) {
      event.preventDefault();
      toggleFavorite(productFromElement(match));
      return;
    }

    if (target.closest("[data-quick-favorite]")) {
      event.preventDefault();
      if (quickCurrent) toggleFavorite(quickCurrent);
      return;
    }

    if (target.closest(".js-quick-close")) {
      event.preventDefault();
      closeQuick();
      return;
    }

    match = target.closest(".js-quick-open, .js-quick-static");
    if (match) {
      event.preventDefault();
      openQuick(productFromElement(match), match);
      return;
    }

    match = target.closest(".faq-item > button");
    if (match) {
      var item = match.closest(".faq-item");
      var opening = !item.classList.contains("open");
      queryAll(".faq-item").forEach(function (other) {
        setFaqItem(other, opening && other === item);
      });
      return;
    }

    match = target.closest("[data-advisor-space]");
    if (match) {
      advisorState.space = match.dataset.advisorSpace;
      advisorState.shape = "";
      advisorState.height = "";
      resetRecommendationResults();
      updateAdvisorShapeAvailability();
      setAdvisorStep(2, Boolean(match.closest("[data-advisor]")));
      if (!match.closest("[data-advisor]")) {
        var advisor = query("[data-advisor]");
        if (advisor) advisor.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return;
    }

    match = target.closest("[data-advisor-shape]");
    if (match) {
      advisorState.shape = match.dataset.advisorShape;
      advisorState.height = "";
      if (!shapeNeedsHeight(advisorState.shape)) {
        setAdvisorActiveStates();
        rankRecommendations(true);
      } else {
        updateAdvisorHeightAvailability();
        setAdvisorStep(3, true);
      }
      return;
    }

    match = target.closest("[data-advisor-height]");
    if (match) {
      advisorState.height = match.dataset.advisorHeight;
      setAdvisorActiveStates();
      rankRecommendations(true);
      return;
    }

    match = target.closest("[data-advisor-back]");
    if (match) {
      setAdvisorStep(Number(match.dataset.advisorBack), true);
      return;
    }

    if (target.closest("[data-advisor-show]")) {
      rankRecommendations(true);
      return;
    }

    if (target.closest("[data-advisor-reset]")) {
      advisorState.space = "";
      advisorState.shape = "";
      advisorState.height = "";
      resetRecommendationResults();
      updateAdvisorShapeAvailability();
      setAdvisorStep(1, false);
      var advisorResetTarget = query("[data-advisor]");
      if (advisorResetTarget) advisorResetTarget.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    var searchOverlay = query("[data-search-overlay]");
    if (searchOverlay && target === searchOverlay) {
      closeSearch();
      return;
    }

    var nav = query("[data-main-nav]");
    if (!nav) return;

    if (target.closest("[data-main-nav] a")) {
      closeSubmenus(null, false);
      if (nav.classList.contains("nav-open")) closeMenu(false);
      return;
    }

    if (!nav.contains(target)) {
      closeSubmenus(null, false);
      if (nav.classList.contains("nav-open")) closeMenu(false);
    }
  }

  function handleChange(event) {
    if (event.target && event.target.matches("[data-compare-toggle]")) {
      toggleComparison(event.target.dataset.compareToggle, event.target.checked);
      return;
    }

    if (!event.target || !event.target.matches('select[name="sort_by"], select[data-sort-by]')) return;
    if (event.target.closest('[data-collection-sort-form]')) return;
    var form = event.target.closest("form");
    if (!form) return;
    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.submit();
  }

  function handleKeydown(event) {
    if ((event.key === "ArrowLeft" || event.key === "ArrowRight") && event.target instanceof Element) {
      var track = event.target.closest("[data-product-track]");
      if (track && event.target === track) {
        event.preventDefault();
        var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        track.scrollBy({
          left: (event.key === "ArrowLeft" ? -1 : 1) * Math.max(track.clientWidth * 0.92, 240),
          behavior: reducedMotion ? "auto" : "smooth"
        });
        window.setTimeout(function () { syncCarousel(track.closest("[data-carousel-scope]")); }, reducedMotion ? 0 : 350);
        return;
      }
    }

    if (event.key === "Escape") {
      var comparison = query("[data-comparison-overlay]");
      var quick = query("[data-quick-backdrop]");
      var search = query("[data-search-overlay]");
      var drawer = query("[data-selection-drawer]");
      var nav = query("[data-main-nav]");
      var openSubmenu = query("[data-submenu-toggle][aria-expanded='true']");

      if (comparison && !comparison.hidden) closeComparison();
      else if (quick && !quick.hidden) closeQuick();
      else if (search && !search.hidden) closeSearch();
      else if (drawer && drawer.classList.contains("open")) closeDrawer();
      else if (openSubmenu) setSubmenuState(openSubmenu, false, true);
      else if (nav && nav.classList.contains("nav-open")) closeMenu();
      return;
    }

    trapFocus(event);
  }

  function localizeStaticLabels() {
    queryAll('button[type="submit"]').forEach(function (button) {
      if (asText(button.textContent) === "Submit") button.textContent = "Odoslať správu";
    });
  }

  function initialize() {
    localizeStaticLabels();
    readFavorites();
    readComparison();
    initializeAccessibility();
    initializeFaq();
    initializeAdvisor();
    initializeCarousels();
    renderFavorites();

    document.addEventListener("click", handleClick);
    document.addEventListener("change", handleChange);
    document.addEventListener("keydown", handleKeydown);

    window.addEventListener("resize", function () {
      syncMenuAccessibility();
      queryAll("[data-carousel-scope]").forEach(syncCarousel);
      syncRecommendationControls();
    });
    window.addEventListener("storage", function (event) {
      if (event.key === FAVORITES_KEY) {
        readFavorites();
        renderFavorites();
      }
    });

    document.addEventListener("shopify:section:load", function () {
      initializeAccessibility();
      initializeFaq();
      initializeAdvisor();
      initializeCarousels();
      renderFavorites();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
